import { Close } from "@carbon/icons-react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ITag } from "../../../../models/tag";
import "./TagFilter.scss";

export interface TagFilterProps {
  selectedTag: ITag | null;
  tagList: ITag[];
  selectTag: (t: ITag) => void;
}

const TagFilter = (props: TagFilterProps) => {
  const { t } = useTranslation();
  const { selectedTag, tagList, selectTag } = props;

  return (
    <div className="tag-filter-list">
      {tagList.map((tag) => {
        const isSelected = selectedTag && selectedTag.name === tag.name;
        return (
          <Button
            className="filter-button"
            key={tag.name}
            data-testid={tag.name}
            variant={isSelected ? "contained" : "text"}
            onClick={() => selectTag(tag)}
          >
            {t(tag.name)}
            {isSelected && <Close className="ml-5" />}
          </Button>
        );
      })}
    </div>
  );
};

export default TagFilter;
